/**
 * Initialize Matomo on consent
 */
/*
 window.matomoLoaded = false;
 window.addEventListener('cookieConsent', function (event) {
     if (event.detail.hasOption('matomo') && window.matomoLoaded === false) {
         var _paq = (window._paq = window._paq || []);

         // tracker methods like "setCustomDimension" should be called before "trackPageView"
         _paq.push(['setDoNotTrack', true]);
         _paq.push(['trackPageView']);
         _paq.push(['enableLinkTracking']);
         (function () {
             //
             // TODO: Change matomo URL below (don’t forget the trailing slash)
             //
             var u = '//www.domain.de/matomo/';
             _paq.push(['setTrackerUrl', u + 'matomo.php']);
             _paq.push(['setSiteId', '1']);
             var d = document,
                 g = d.createElement('script'),
                 s = d.getElementsByTagName('script')[0];
             g.async = true;
             g.src = u + 'matomo.js';
             s.parentNode.insertBefore(g, s);
         })();

         window.matomoLoaded = true;
     }
 });
*/

/**
 * Component scripts
 */
import '../components/molecules/consent-dialog/_consent-dialog.js';
import '../components/molecules/lazy-load/_lazy-load.js';
import '../components/atoms/video/_video.js';

// import '../components/molecules/lightbox/_lightbox.js';
import initLightBox from '../components/molecules/lightbox/_lightbox.js';
import Accordion from '../components/molecules/accordion/_accordion.js';
import Breadcrumb from '../components/molecules/breadcrumb/_breadcrumb.js';
import Dialog from '../components/molecules/dialog/_dialog.js';
import DialogCustom from '../components/molecules/dialog-custom/_dialog-custom.js';
import DisclosureButton from '../components/molecules/disclosure-button/_disclosure-button.js';
import DisclosureNav from '../components/molecules/disclosure-nav/_disclosure-nav.js';

// import NavMobile from '../components/molecules/nav-mobile/_nav-mobile.js';
import navMobile from '../components/molecules/nav-mobile/_nav-mobile.js';
import Drawer from '../components/molecules/drawer/_drawer.js';
import Header from '../components/organisms/header/_header.js';
import loadingButton from '../components/atoms/button/_button.js';
import Masonry from 'masonry-layout';
import Slideshow from '../components/molecules/slideshow/_slideshow.js';
import TeaserHasLink from '../components/molecules/teaser/_teaser.js';
import showOnIntersect from '../components/molecules/fab/_show-on-intersect.js';
import Tabs from '../components/molecules/tabs/_tabs.js';
import Toggle from '../components/molecules/toggle-button/_toggle-button.js';

function initAll() {
    navMobile();
    loadingButton();
    showOnIntersect();

    const $accordionList = document.getElementsByClassName('js-accordion');
    for (const $accordion of $accordionList) {
        new Accordion($accordion).init();
    }

    const $disclosureNavElements = document.querySelectorAll('.js-disclosure-nav');
    for (const $disclosureNavElement of $disclosureNavElements) {
        new DisclosureNav($disclosureNavElement).init();
    }

    const $header = document.getElementsByClassName('js-header')[0];
    let header;
    if ($header) {
        header = new Header($header);
        header.init();
    }

    //Quick fix Bullets: teaser-stage needs to init last in this case
    let $slideShowNodes = Array.from(document.querySelectorAll('.js-slideshow')).sort((x) =>
        x.querySelector('.c-teaser-stage') ? 1 : -1
    );

    $slideShowNodes.forEach(($slideShowNode, index, $slideShowNodes) => {
        // no slider for single images
        if ($slideShowNode.querySelectorAll('li').length !== 1) {
            new Slideshow($slideShowNode, index, $slideShowNodes).init();
        } else {
            const slideshowNav = $slideShowNode.querySelector('.c-slideshow__navigation');
            if (slideshowNav) {
                setTimeout(() => {
                    slideshowNav.style.display = 'none';
                });
            }
        }
    });

    const $breadcrumb = document.getElementsByClassName('js-breadcrumb')[0];
    if ($breadcrumb) {
        new Breadcrumb($breadcrumb).init();
    }

    const $teasersHasLink = document.getElementsByClassName('js-teaser--has-link');
    for (const $teaserHasLink of $teasersHasLink) {
        new TeaserHasLink($teaserHasLink).init();
    }

    const $masonryGrids = document.querySelectorAll('.js-grid-masonry');
    for (const $masonryGrid of $masonryGrids) {
        new Masonry($masonryGrid, {
            columnWidth: '.js-grid-sizer',
            itemSelector: '.js-grid-masonry > .js-grid-masonry__item',
        });
    }

    // hiding and showing action bar or action button elem when footer is in view/hidden
    const $observable = document.querySelector('.js-observe-visiblity'); // elem to watch
    const $target = document.querySelector('.js-teaser--action'); // elem to hide/show

    function handleIntersection(entries) {
        entries.forEach((entry) => {
            // hide when footer is visible
            if (entry.isIntersecting) {
                $target.style.display = 'none';
            } else {
                // show when footer is hidden
                $target.style.display = 'block';
            }
        });
    }

    if ($target && $observable) {
        new IntersectionObserver(handleIntersection).observe($observable);
    }

    const $lightboxtriggers = document.querySelectorAll('.js-lightbox-trigger');

    for (let $lightboxtrigger of $lightboxtriggers) {
        $lightboxtrigger.addEventListener('click', initLightBox);
    }

    // percentPosition: true,
    // horizontalOrder: true,

    document.querySelectorAll('.js-dialog').forEach((node) => new Dialog(node));
    document.querySelectorAll('.js-dialog-custom').forEach((node) => new DialogCustom(node));

    document.querySelectorAll('.js-drawer').forEach((node) => new Drawer(node));

    const $tabs = document.querySelectorAll('.js-tabs');
    for (const $tab of $tabs) {
        new Tabs($tab).init();
    }

    /*
    document
        .querySelectorAll('.js-nav-mobile')
        .forEach((node) => new NavMobile(node));
    */
    document.querySelectorAll('.js-disclosure-button').forEach((node) => new DisclosureButton(node).init());

    const $toggles = document.querySelectorAll('.js-toggle');
    for (const $toggle of $toggles) {
        new Toggle($toggle, $toggles).init();
    }

    // TODO: Refactor global for loop into func and add sanity check that.
    const tables = document.querySelectorAll('table');
    for (const table of tables) {
        // create wrapper container
        var wrapper = document.createElement('div');

        // insert wrapper before el in the DOM tree
        table.parentNode.insertBefore(wrapper, table);

        // move el into wrapper
        wrapper.classList.add('c-table');
        wrapper.appendChild(table);
    }

    const pdfClassLinks = document.querySelectorAll('a[href$=".pdf"]');
    for (const pdfClassLink of pdfClassLinks) {
        pdfClassLink.setAttribute('target', '_blank');
    }

    const externClassLinks = document.querySelectorAll('p a[href^="http"], p a[href^="//"]');
    for (const externClassLink of externClassLinks) {
        externClassLink.setAttribute('target', '_blank');
    }

    const msoClassLinks = document.querySelectorAll('.MsoNormal');
    for (const msoClasLinks of msoClassLinks) {
        // msoClasLinks.classList.remove('MsoNormal');
        msoClasLinks.removeAttribute('class');
        msoClasLinks.removeAttribute('style');
    }

    const scrollTopBtn = document.querySelector('.js-scroll-top');
    if (scrollTopBtn) {
        //console.log(scrollTopBtn);
        scrollTopBtn.addEventListener('click', () => {
            // Scrolling to the top of a page
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth',
            });
        });
    }

    function toggleClearButton() {
        const $input = this;
        const $wrapper = $input.closest('.c-form__group--inline');
        const $button = $wrapper.querySelector('button');
        $button.hidden = $input.value.length === 0;
    }

    function clearInput(e) {
        const $wrapper = e.target.closest('.c-form__group--inline');
        const $input = $wrapper.querySelector('input');
        if ($input) {
            $input.value = '';
            $input.focus();
            e.target.hidden = $input.value.length === 0;
        }
    }

    const clearInputs = document.querySelectorAll('.js-clear-input');
    for (let btn of clearInputs) {
        btn.addEventListener('click', clearInput);
        const $input = btn.previousElementSibling;
        $input.addEventListener('input', toggleClearButton);
    }

    let locations = [];

    const $locationId = document.querySelector('[data-location-id]');

    function uniqByKeepFirst(a, key) {
        let seen = new Set();
        return a.filter((item) => {
            let k = key(item);
            return seen.has(k) ? false : seen.add(k);
        });
    }

    function setLocation() {
        locations = localStorage.getItem('lf_locations') ? JSON.parse(localStorage.getItem('lf_locations')) : [];

        const {
            dataset: { locationId },
        } = document.querySelector('[data-location-id]');
        const {
            dataset: { locationName },
        } = document.querySelector('[data-location-name]');
        const {
            dataset: { locationCity },
        } = document.querySelector('[data-location-city]');
        const {
            dataset: { locationHref },
        } = document.querySelector('[data-location-href]');

        if (locationId && locationName && locationCity && locationHref) {
            const location = {
                id: locationId,
                name: locationName,
                city: locationCity,
                href: locationHref,
            };

            // update location with new values, filter old and empty

            locations.unshift(location);

            // remove second duplicate id from array
            locations = uniqByKeepFirst(locations, (item) => item.id);

            // filter empty entries
            locations = locations.filter((el) => el.id !== '');

            // no more than 4 locations allowed
            locations.splice(4);

            localStorage.setItem('lf_locations', JSON.stringify(locations));
        }
    }

    if ($locationId) {
        const {
            dataset: { locationId },
        } = document.querySelector('[data-location-id]');

        // location id is found => on location page => save location
        if (locationId !== '') {
            setLocation();
        }
    } else {
        // if not on location page update action bar with last location
        updateActionBar();
    }

    function checkLocations() {
        const $locationTeasers = document.querySelector('.js-teaser-set--locations');

        // don't prefill example page
        if (document.querySelector('.plugin-locations-latest')) {
            return;
        }

        if ($locationTeasers) {
            locations = localStorage.getItem('lf_locations') ? JSON.parse(localStorage.getItem('lf_locations')) : [];

            document.querySelector('.js-teaser-set--locations').innerHTML = '';

            if (locations.length) {
                document.querySelector('.js-teaser-set--locations').closest('.o-container').style.display = 'block';
                generateLocationTeasers();
            } else {
                document.querySelector('.js-teaser-set--locations').closest('.o-container').style.display = 'none';
            }
        }
    }

    function teaserTemplate(location) {
        return `<li class="o-grid__col--12 o-grid__col--6@md o-grid__col--3@lg">
                    <div class="c-teaser u-background-color-white c-teaser--has-link js-teaser--has-link">
                        <div class="c-teaser__body">
                            <div class="c-teaser__header">
                                <div class="c-teaser__meta">
                                    <div class="c-meta">
                                        <ul class="c-meta__list">
                                            <li class="c-meta__item">
                                                <span class="c-meta__text">${location.name}</span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <strong class="c-teaser__heading u-text-h4">
                                    <a class="c-teaser__link" href="${location.href}" target="" draggable="false">
                                        <span class="c-teaser__heading-text">${location.city}</span>
                                    </a>
                                </strong>
                            </div>
                        </div>
                    </div>
                </li>`;
    }

    function generateLocationTeasers() {
        document.querySelector('.js-teaser-set--locations').style.display = 'flex';
        for (let location of locations) {
            document.querySelector('.js-teaser-set--locations').insertAdjacentHTML('beforeend', teaserTemplate(location));
        }
    }

    function updateActionBar() {
        const $actionBar = document.querySelector('.c-teaser--action-bar.js-teaser--action');

        locations = localStorage.getItem('lf_locations') ? JSON.parse(localStorage.getItem('lf_locations')) : [];

        if (!locations.length) return;

        let [lastLocation] = locations;

        const template = `<p>Sie waren zuletzt bei</p>
        <div class="u-text-h4"><a href="${lastLocation.href}" class="location-link">${lastLocation.name}</a></div>`;
        if ($actionBar) {
            $actionBar.querySelector('h2').parentNode.insertAdjacentHTML('afterbegin', template);
            $actionBar.querySelector('h2').remove();
        }
    }

    function visitedTagTemplate() {
        return `<li class="c-meta__item" style="display: flex;">
                    <span class="c-meta__label u-sr-only">Besucht:&nbsp;</span>
                    <span class="c-meta__text">Besucht</span>
                </li>`;
    }

    function checkJobs() {
        const $jobs = document.querySelectorAll('.js-jobslist');
        const $jobId = document.querySelector('[data-joboffer-id]');

        let jobIds = [];

        if (!$jobId && $jobs.length === 0) {
            return;
        }

        //retrieve jobs visited array from local storage
        jobIds = localStorage.getItem('lf_job_ids') ? JSON.parse(localStorage.getItem('lf_job_ids')) : [];
        jobIds = jobIds.filter((el) => el);

        if ($jobId) {
            //save to local storage jobs visited aray
            const {
                dataset: { jobofferId },
            } = $jobId;
            jobIds.push(jobofferId);
            jobIds = [...new Set(jobIds)]; // no duplicates
            localStorage.setItem('lf_job_ids', JSON.stringify(jobIds));
        }

        for (let $job of $jobs) {
            // dont add if already
            const $metaTag = $job.querySelector('.c-meta__list:has(.c-meta__item:only-child)');

            const {
                dataset: { id },
            } = $job;
            if (jobIds.includes(id) && $metaTag) {
                $metaTag.insertAdjacentHTML('beforeend', visitedTagTemplate());
            }
        }
    }

    checkJobs();
    checkLocations();

    /*
    window.navigation.addEventListener('navigate', () => {
        setTimeout(() => {
            checkJobs();
            checkLocations();
        }, 500);
    });
    */

    function handleBackButton(e) {
        e.preventDefault();

        const prevLink = document.referrer;

        if (prevLink && prevLink.includes('wirpflegen')) {
            history.back();
        } else {
            location.href = e.target.href;
        }
    }

    const $closeBtns = document.querySelectorAll('.js-backlink');
    for (let closeBtn of $closeBtns) {
        closeBtn.addEventListener('click', handleBackButton);
    }

    function debounce(func) {
        let timer;
        return function (event) {
            if (timer) clearTimeout(timer);
            timer = setTimeout(func, 400, event);
        };
    }

    function setSizes() {
        document.querySelectorAll('img[loading="lazy"]').forEach((elem) => {
            const w = elem.width;

            // adding sizes to srcset images
            const hasSrcSet = elem.hasAttribute('srcset');
            const parentPicture = elem.closest('picture');

            // if there is a parent picture elem get source elements
            if (parentPicture) {
                const pictureSources = Array.from(parentPicture.querySelectorAll('source'));
                for (let pictureSource of pictureSources) {
                    pictureSource.setAttribute('sizes', w + 'px');
                }
            }

            if (w && hasSrcSet) {
                elem.setAttribute('sizes', w + 'px');
            }
        });
    }

    setSizes();

    window.addEventListener(
        'resize',
        debounce(function () {
            setSizes();
        })
    );
}

if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAll);
    } else {
        initAll();
    }
}
